const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "coupon":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "goods",
    reducer: reducer,
};

export default data;
